/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export function sprayNYFat(x, y, { state, canvas, notifications }) {
  const ctx = canvas.activeCtx;
  const config = state.config;
  const cansData = state.cansData;
  const dripMap = state.dripMap;
  const paintedPixels = state.paintedPixels;
  const presetConfig = state.presetConfig || {};
  const enableDrips = state.enableDrips;
  const paintConsumption = state.paintConsumption || 1;
  const activeCan = cansData.find(c => c.id === config.activeCanId);
  if (!activeCan || activeCan.paintLeft <= 0) {
    if (activeCan && activeCan.paintLeft <= 0) {
      notifications.showPaintEmptyToast(config.activeCanId);
    }
    return;
  }
  const now = performance.now();
  let speed = 0;
  let moveAngle = 0;
  if (state.lastSprayPos && state.lastSprayTime !== null) {
    const dt = now - state.lastSprayTime;
    const dist = Math.hypot(x - state.lastSprayPos.x, y - state.lastSprayPos.y);
    speed = Math.min(1, dist / (dt || 1) / config.speedFactor);
    moveAngle = Math.atan2(y - state.lastSprayPos.y, x - state.lastSprayPos.x);
  }
  const scale = config.lineScale;
  const layers = [
    { count: 0.15, alpha: 0.02, sizeMult: 0.5, rMin: 0.1, rMax: 2.45 },
    { count: 0.25, alpha: 0.1, sizeMult: 1.0, rMin: 1.2, rMax: 1.6 }
  ];
  const isFlatMode = state.flatMode === true;
  const stretchFactor = 1 + Math.min(1.5, speed * 3);
  const hasLastPos = !!state.lastSprayPos && speed > 0.15;
  const lx = hasLastPos ? state.lastSprayPos.x : x;
  const ly = hasLastPos ? state.lastSprayPos.y : y;
  function checkStaticSprayLocal(xp, yp) {
    if (!state.lastStaticSprayPos) {
      state.lastStaticSprayPos = { x: xp, y: yp };
      state.staticSprayStartTime = Date.now();
      state.isStaticSpraying = true;
      return false;
    }
    const distance = Math.hypot(xp - state.lastStaticSprayPos.x, yp - state.lastStaticSprayPos.y);
    const threshold = 5;
    if (distance > threshold) {
      state.lastStaticSprayPos = { x: xp, y: yp };
      state.staticSprayStartTime = Date.now();
      state.isStaticSpraying = false;
      return false;
    }
    const timeHeld = Date.now() - state.staticSprayStartTime;
    if (timeHeld > 100) {
      state.isStaticSpraying = true;
      return timeHeld;
    }
    state.isStaticSpraying = false;
    return false;
  }
  const timeHeld = checkStaticSprayLocal(x, y);
  let paintUsedCount = 0;
  ctx.fillStyle = config.currentColor;
  const baseSpeedAlpha = 0.25 - (0.15 * speed);
  for (const layer of layers) {
    const layerCount = Math.floor(config.dotsPerTick * layer.count);
    ctx.globalAlpha = Math.max(0.05, baseSpeedAlpha * layer.alpha * 0.95);
    let hasArc = false;
    ctx.beginPath();
    for (let i = 0; i < layerCount; i++) {
      const t = hasLastPos ? Math.random() : 0;
      const cx = lx + (x - lx) * t;
      const cy = ly + (y - ly) * t;
      const r = (layer.rMin + Math.random() * (layer.rMax - layer.rMin)) * config.sprayRadius * scale;
      const baseAngle = Math.random() * 2 * Math.PI;
      let dx, dy;
      if (!isFlatMode && speed > 0.1 && stretchFactor > 1.1) {
        const stretchedX = Math.cos(baseAngle) * r * stretchFactor;
        const stretchedY = Math.sin(baseAngle) * r / stretchFactor;
        dx = stretchedX * Math.cos(moveAngle) - stretchedY * Math.sin(moveAngle);
        dy = stretchedX * Math.sin(moveAngle) + stretchedY * Math.cos(moveAngle);
      } else {
        dx = Math.cos(baseAngle) * r;
        dy = Math.sin(baseAngle) * r;
      }
      const distFromCenter = r / (config.sprayRadius * scale);
      const sizeVariation = 0.4 + distFromCenter * 0.6;
      const size = (0.6 + Math.random() * 0.5) * scale * sizeVariation * layer.sizeMult;
      if (size <= 2.5) {
        ctx.fillRect(cx + dx - size, cy + dy - size, size * 2, size * 2);
      } else {
        ctx.moveTo(cx + dx + size, cy + dy);
        ctx.arc(cx + dx, cy + dy, size, 0, 2 * Math.PI);
        hasArc = true;
      }
      if (i % 2 === 0) {
        const px = Math.round(cx + dx);
        const py = Math.round(cy + dy);
        const key = (px << 12) | (py & 0xFFF);
        if (!paintedPixels.has(key)) { paintedPixels.add(key); paintUsedCount += 2; }
      }
      if (timeHeld && enableDrips) {
        const cellX = Math.round(cx + dx);
        const cellY = Math.round(cy + dy);
        const cellKey = (cellX << 12) | (cellY & 0xFFF);
        dripMap[cellKey] = (dripMap[cellKey] || 0) + 1;
        const drops = dripMap[cellKey];
        const threshold = Math.max(8, 12 * scale);
        if (drops > threshold && drops % 3 === 0 && state.isStaticSpraying) {
          const dripLen = Math.min(
            25 * scale * (1 + timeHeld / 300),
            Math.sqrt(drops - threshold) * 0.4 * scale + Math.random() * 3
          );
          ctx.save();
          ctx.globalAlpha = 0.1 + Math.random() * 0.05;
          ctx.strokeStyle = config.currentColor;
          const dripWidth = presetConfig.dripWidth || 0.5;
          const dripWidthVariation = presetConfig.dripWidthVariation || 0.2;
          ctx.lineWidth = dripWidth + Math.random() * dripWidthVariation;
          ctx.beginPath();
          ctx.moveTo(cellX + (Math.random() * 2 - 1), cellY + size / 4);
          ctx.lineTo(cellX + (Math.random() * 2 - 1), cellY + size / 2 + dripLen);
          ctx.stroke();
          ctx.restore();
        }
      }
    }
    if (hasArc) {
      ctx.fill();
    }
  }
  if (presetConfig.edgeFog) {
    const fogCount = Math.floor(config.dotsPerTick * 0.1);
    ctx.globalAlpha = 0.035;
    let hasFogArc = false;
    ctx.beginPath();
    for (let i = 0; i < fogCount; i++) {
      const fogRadius = config.sprayRadius * scale * (0.9 + Math.random() * 0.25);
      const fogAngle = Math.random() * 2 * Math.PI;
      const fogX = Math.cos(fogAngle) * fogRadius;
      const fogY = Math.sin(fogAngle) * fogRadius;
      const fogSize = 0.3 * scale;
      if (fogSize <= 2.5) {
        ctx.fillRect(x + fogX - fogSize, y + fogY - fogSize, fogSize * 2, fogSize * 2);
      } else {
        ctx.moveTo(x + fogX + fogSize, y + fogY);
        ctx.arc(x + fogX, y + fogY, fogSize, 0, 2 * Math.PI);
        hasFogArc = true;
      }
      if (i % 2 === 0) {
        const px = Math.round(x + fogX);
        const py = Math.round(y + fogY);
        const key = (px << 12) | (py & 0xFFF);
        if (!paintedPixels.has(key)) {
          paintedPixels.add(key);
          paintUsedCount += 2;
        }
      }
    }
    if (hasFogArc) {
      ctx.fill();
    }
  }
  if (paintUsedCount > 0) {
    const canvasEl = canvas.canvas;
    const totalPixels = (canvasEl && canvasEl.width && canvasEl.height) ? (canvasEl.width * canvasEl.height) : 1;
    const pixelsPerCan = state.pixelsPerCan || 960000;
    const paintUnitsPerPixel = state.config.paintMax / pixelsPerCan;
    const totalPaintUsed = Math.max(1, Math.round(paintUsedCount * paintUnitsPerPixel * (state.paintConsumption || 1)));
    state.updateCanPaint(state.config.activeCanId, totalPaintUsed);
  }
  state.lastSprayPos = { x, y };
  state.lastSprayTime = now;
  ctx.globalAlpha = 1;
}
